/* eslint-disable folders/match-regex */
import { setupI18n } from "@lingui/core";
import { I18nProvider } from "@lingui/react";

export { I18nProvider };

export const i18n = setupI18n({
  language: "en",
  catalogs: {}
});

export const LANGUAGE_CODE = {
  English: "en",
  Spanish: "es",
  Portuguese: "pt",
  French: "fr",
  German: "de",
  Italian: "it",
  Russian: "ru",
  Chinese: "zh-hans",
  Korean: "ko",
  Japanese: "ja",
  Vietnamese: "vi",
  Thai: "th",
  Arabic: "ar",
  Polish: "pl"
};

export function loadLocale(localeSrc) {
  return new Promise((resolve, reject) => {
    const moduleBlob = new Blob(
      [`import * as m from '${localeSrc}';`, `window['${localeSrc}'] = m`],
      {
        type: "text/javascript"
      }
    );

    let script = document.getElementById("LOCALES");
    if (script) {
      document.body.removeChild(script);
    }
    script = document.createElement("script");
    script.id = "LOCALES";
    script.type = "module";
    script.src = URL.createObjectURL(moduleBlob);
    script.async = true;
    script.onload = () => {
      console.info("succes calling ", window[localeSrc]);
      resolve(window[localeSrc]);
    };
    script.onerror = (err) => {
      console.info("on error is calling ", err);
      reject();
    };
    document.body.appendChild(script);
  });
}

export function parseMissingMessage(messageId = "", contextFunc) {
  if (!messageId) return messageId;
  if (messageId.includes("{") === false) {
    return messageId;
  }
  let str = "";
  let strArr = [];
  // let insideBlock = false;
  for (let char of messageId) {
    if (char === "{") {
      strArr.push(str);
      str = "";
      continue;
    }
    if (char === "}") {
      strArr.push(contextFunc(str));
      str = "";
      continue;
    }
    str = str + char;
  }
  if (str.length > 0) {
    strArr.push(str);
  }
  return strArr;
}
